import { DisplayReportJob } from '../../models/ui';
import { ReportingActions } from "./reporting.actions";
import * as ui from "../../models/ui";

export interface ReportingState {
	reportJobs: DisplayReportJob[]
}

const initialState: ReportingState  = {
	reportJobs: []
};

export const reportingReducer = (state: ReportingState = initialState, action): ReportingState => {
	switch (action.type) {
		case ReportingActions.SET_REPORT_JOB:
			return {
				reportJobs: [...state.reportJobs, action.payload]
			}

		case ReportingActions.UPDATE_REPORT_JOB: {
			const upDrj: ui.DisplayReportJob = <ui.DisplayReportJob> action.payload;
			let newDisplayReportJobs = [...state.reportJobs]
				.map(drj => drj.reportJob.job === upDrj.reportJob.job ? upDrj : drj)
			return Object.assign({}, state, { reportJobs: newDisplayReportJobs})
		}

		case ReportingActions.DELETE_REPORT_JOB: {
			const drj: ui.DisplayReportJob = <ui.DisplayReportJob>action.payload;
			const index = state.reportJobs.map(displayReportJob => displayReportJob.reportJob.job).indexOf(drj.reportJob.job);
			const newDisplayReportJobs = [...state.reportJobs]
			newDisplayReportJobs.splice(index, 1);
			return Object.assign({}, state, { reportJobs: newDisplayReportJobs})
		}

		default: return state;
	}
};



// WEBPACK FOOTER //
// ./src/app/components/reporting/reporting.reducer.ts